import { CrudDecoratorCloseEvent, DataHeader, TableRowDisplayEvent } from "@mcleod/components";
import { ModelRow } from "@mcleod/core";
import { AutogenLayoutDetentionDefinitionTable } from "./autogen/AutogenLayoutDetentionDefinitionTable";
import { DetentionDefinition } from "./DetentionDefinition";

export class DetentionDefinitionTable extends AutogenLayoutDetentionDefinitionTable {
    override onLoad(): void {
        this.tableDetentionDefinition.addButtonCaption = "Add Detention Definition";
    }

    tableDetentionDefinitionOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const modelRow = tableRow.data as ModelRow;
        const star = tableRow.findComponentById("imageStar");
        if (star) {
            star.visible = modelRow.get("global_definition") == "Y" && modelRow.get("is_active") == "Y" ? true : false;
        }
    }
    
    tableDetentionDefinitionAfterCrudClose(event: CrudDecoratorCloseEvent) {
        const dataheader = event.target as DataHeader;
        const detentionDef = dataheader.layout as DetentionDefinition
        if (detentionDef.copiedDefinition) {
            this.mainDataSource.search(this.mainDataSource.lastSearch);
        }
    }

}